import React from 'react';
import { FaShieldAlt, FaFileContract, FaUserMinus, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './LegalPages.css';

const LegalLayout = ({ title, icon: Icon, children }) => {
  const navigate = useNavigate();
  return (
    <div className="legal-container">
      <div className="legal-glass-card">
        <button className="legal-back-button" onClick={() => navigate(-1)}>
          <FaArrowLeft /> العودة
        </button>
        <div className="legal-header">
          <div className="legal-icon-wrapper">
            <Icon />
          </div>
          <h1 className="legal-title">{title}</h1>
        </div>
        <div className="legal-content">
          {children}
        </div>
        <div className="legal-footer">
          <p>© 2024 Clickfish DZ - جميع الحقوق محفوظة</p>
        </div>
      </div>
    </div>
  );
};

export const PrivacyPolicy = () => (
  <LegalLayout title="سياسة الخصوصية | Privacy Policy" icon={FaShieldAlt}>
    <section>
      <h2>1. المعلومات التي نجمعها | Information We Collect</h2>
      <div className="bilingual-text">
        <p className="ar">عند استخدامك لبوت Clickfish DZ عبر فيسبوك، قد نجمع المعلومات التالية:</p>
        <p className="en">When using the Clickfish DZ bot via Facebook, we may collect the following information:</p>
      </div>
      <ul>
        <li>
          <span className="ar">اسمك وصورتك الشخصية (كما تظهر في حسابك على فيسبوك).</span>
          <span className="en">Your name and profile picture (as they appear on your Facebook account).</span>
        </li>
        <li>
          <span className="ar">الرسائل التي ترسلها للبوت لغرض الاستفسار أو الطلب.</span>
          <span className="en">Messages you send to the bot for inquiries or orders.</span>
        </li>
        <li>
          <span className="ar">معلومات التواصل والطلب التي تقدمها (مثل رقم الهاتف والعنوان).</span>
          <span className="en">Contact and order information you provide (such as phone number and address).</span>
        </li>
      </ul>
    </section>
    
    <section>
      <h2>2. كيف نستخدم معلوماتك | How We Use Your Information</h2>
      <div className="bilingual-text">
        <p className="ar">نستخدم المعلومات التي نجمعها لـ:</p>
        <p className="en">We use the collected information to:</p>
      </div>
      <ul>
        <li>
          <span className="ar">معالجة طلبات شراء الأسماك والنباتات والمستلزمات.</span>
          <span className="en">Process orders for fish, plants, and supplies.</span>
        </li>
        <li>
          <span className="ar">تقديم الدعم الفني والإجابة على استفساراتك.</span>
          <span className="en">Provide customer support and answer your inquiries.</span>
        </li>
        <li>
          <span className="ar">تحسين تجربة المستخدم وأداء البوت.</span>
          <span className="en">Improve user experience and bot performance.</span>
        </li>
      </ul>
    </section>

    <section>
      <h2>3. حماية البيانات | Data Protection</h2>
      <div className="bilingual-text">
        <p className="ar">نحن ملتزمون بحماية بياناتك. يتم تخزين المعلومات بشكل آمن في قواعد بيانات مشفرة (Firebase)، ولا نقوم ببيع أو مشاركة بياناتك مع أطراف ثالثة لأغراض تسويقية.</p>
        <p className="en">We are committed to protecting your data. Information is stored securely in encrypted databases (Firebase), and we do not sell or share your data with third parties for marketing purposes.</p>
      </div>
    </section>

    <section>
      <h2>4. ملفات تعريف الارتباط | Cookies</h2>
      <div className="bilingual-text">
        <p className="ar">يستخدم موقعنا ملفات تعريف الارتباط لتحسين تجربة التصفح وتذكر تفضيلاتك.</p>
        <p className="en">Our website uses cookies to enhance the browsing experience and remember your preferences.</p>
      </div>
    </section>
  </LegalLayout>
);

export const TermsOfService = () => (
  <LegalLayout title="شروط الخدمة | Terms of Service" icon={FaFileContract}>
    <section>
      <h2>1. قبول الشروط | Acceptance of Terms</h2>
      <div className="bilingual-text">
        <p className="ar">باستخدامك لبوت Clickfish DZ أو موقعنا الإلكتروني، فإنك توافق على الالتزام بهذه الشروط.</p>
        <p className="en">By using the Clickfish DZ bot or our website, you agree to be bound by these terms.</p>
      </div>
    </section>
    
    <section>
      <h2>2. وصف الخدمة | Service Description</h2>
      <div className="bilingual-text">
        <p className="ar">Clickfish DZ هو متجر إلكتروني متخصص في بيع أسماك الزينة، النباتات المائية، والأحواض. نوفر خدمة الطلب الآلي عبر بوت مسنجر.</p>
        <p className="en">Clickfish DZ is an online store specializing in the sale of ornamental fish, aquatic plants, and aquariums. We provide automated ordering services via Messenger bot.</p>
      </div>
    </section>

    <section>
      <h2>3. الطلبات والدفع | Orders and Payment</h2>
      <div className="bilingual-text">
        <p className="ar">تعتبر الطلبات نهائية بمجرد تأكيدها عبر البوت أو الموقع. يتم تحديد طرق الدفع والتوصيل عند التأكيد.</p>
        <p className="en">Orders are considered final once confirmed via the bot or website. Payment and delivery methods are determined upon confirmation.</p>
      </div>
    </section>

    <section>
      <h2>4. حدود المسؤولية | Limitation of Liability</h2>
      <div className="bilingual-text">
        <p className="ar">نحن نسعى لتقديم أدق المعلومات حول المنتجات، ولكننا غير مسؤولين عن أي أضرار ناتجة عن سوء استخدام المنتجات أو المعلومات المقدمة.</p>
        <p className="en">We strive to provide the most accurate information about products, but we are not responsible for any damages resulting from misuse of products or information provided.</p>
      </div>
    </section>
  </LegalLayout>
);

export const DataDeletion = () => (
  <LegalLayout title="حذف البيانات | User Data Deletion" icon={FaUserMinus}>
    <section>
      <h2>تعليمات حذف البيانات | Data Deletion Instructions</h2>
      <div className="bilingual-text">
        <p className="ar">نحن نحترم خصوصيتك ونوفر لك التحكم الكامل في بياناتك. إذا كنت ترغب في حذف بياناتك من أنظمتنا، يرجى اتباع الخطوات التالية:</p>
        <p className="en">We respect your privacy and provide you with full control over your data. If you wish to delete your data from our systems, please follow these steps:</p>
      </div>
      
      <h3>الخيار 1: عبر إعدادات فيسبوك | Option 1: Via Facebook Settings</h3>
      <ol>
        <li>
          <span className="ar">انتقل إلى حسابك على فيسبوك > الإعدادات والخصوصية > الإعدادات.</span>
          <span className="en">Go to your Facebook account > Settings & Privacy > Settings.</span>
        </li>
        <li>
          <span className="ar">ابحث عن "التطبيقات ومواقع الويب".</span>
          <span className="en">Search for "Apps and Websites".</span>
        </li>
        <li>
          <span className="ar">ابحث عن <strong>Clickfish DZ</strong> وانقر على "إزالة".</span>
          <span className="en">Find <strong>Clickfish DZ</strong> and click "Remove".</span>
        </li>
      </ol>

      <h3>الخيار 2: طلب مباشر | Option 2: Direct Request</h3>
      <div className="bilingual-text">
        <p className="ar">يمكنك إرسال رسالة مباشرة للبوت بكلمة "حذف بياناتي" أو "Delete my data"، أو التواصل معنا عبر صفحتنا الرسمية على فيسبوك، وسنقوم بحذف كافة سجلاتك من قواعد بياناتنا في غضون 24 ساعة.</p>
        <p className="en">You can send a direct message to the bot with the phrase "حذف بياناتي" or "Delete my data", or contact us via our official Facebook page, and we will delete all your records from our databases within 24 hours.</p>
      </div>
    </section>
  </LegalLayout>
);
